import { FC } from "react";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";

interface TourComponentProps {
  showTour: boolean
  steps: Array<Step>
  onTourClose: () => void;
}



export const TourComponent: FC<TourComponentProps> = ({showTour, steps, onTourClose}) => {

  const buttonsText = {
    back: 'Atrás',
    close: 'Cerrar',
    last: 'Finalizar',
    next: 'Siguiente',
    skip: 'Saltar',
    nextLabelWithProgress: 'Siguiente ({step} de {steps})'
  }

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action } = data;

    if (action === 'close') {
      onTourClose();
      return;
    }


    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) { 
      onTourClose();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={showTour}
      continuous
      showProgress
      locale={buttonsText}
      callback={handleJoyrideCallback}
      styles={{
        tooltip: {
          borderRadius: '1rem',
        },
        buttonNext: {
          backgroundColor: 'transparent',
          color: '#005BBB',
          border: 'solid 1px #005BBB'
        },
        buttonBack: {
          color: '#999999',
        },
        buttonClose: {
          fontSize: 8,
          width: 10,
          height: 10
        },
      }}

    />
  );
};
